import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLanguage } from "./LanguageContext";
import ReactSelect from "react-select";

const customSelectStyles = {
  control: (provided) => ({
    ...provided,
    width: "100%", // Make it flexible
    minHeight: "40px", // Adjust default height
    borderRadius: "12px",
    backgroundColor: "#f8f9fa",
    border: "1px solid #dcdcdc",
    fontSize: "14px",
    fontFamily: "Inter, sans-serif",
    color: "#333",
    boxShadow: "none",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "12px",
    fontSize: "14px",
    fontFamily: "Inter, sans-serif",
    zIndex: 999, // Ensure menu is on top of other elements
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "#fff" : "#333",
    backgroundColor: state.isSelected ? "#007bff" : "#f8f9fa",
    fontSize: "14px",
    padding: "10px 15px",
    fontWeight: state.isSelected ? 700 : 400,
  }),
};

const LanguageDiv = styled.div`
  display: flex;
  align-items: center;
  color: #b0b7c3;
  width: 200px;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  border-radius: 14px;
  border: none;
  background-color: #f8f9fa;
  font-weight: 500;
  justify-content: center;
  height: 58px;
  // position: absolute;
  // right: 2%;
  // padding: 6px;
`;

const Select = styled.select`
  width: 100%;
  height: 35px;
  color: #b0b7c3;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  border-radius: 14px;
  border: none;
  background-color: #f8f9fa;
  padding-left: 5px;
  border: none;
  margin-left: 10px;

  option {
    color: black;
    background-color: #f8f9fa;
    font-weight: 700;
    color: #b0b7c3;
    display: flex;
    white-space: pre;
    border: none;
    min-height: 20px;
    font-size: 14px;
    padding: 0px 2px 1px;
  }
`;

const languageOptions = [
  { label: "English", value: "en" },
  { label: "Arabic", value: "ar" },
];
const LanguageComponent = () => {
  const { language, changeLanguage } = useLanguage();
  const [selectedLanguage, setSelectedLanguage] = useState();

  const handleLanguageChange = (value) => {
    changeLanguage(value.value);
  };

  useEffect(() => {
    setSelectedLanguage(
      languageOptions.find((lan) => lan.value === language) ||
        languageOptions[0]
    );
  }, [language]);

  return (
    <ReactSelect
      styles={customSelectStyles}
      // styles={{ width: "100%" }}
      value={selectedLanguage}
      options={languageOptions}
      onChange={handleLanguageChange}
    />
  );
};

export default LanguageComponent;
